import React from "react";
import { PropertyEditorFloat, PropertyEditorFloatInterface } from "../PropertyEditorFloat";
import { StoryNode } from "../../StoryBook/StoryData";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class TextData implements PropertyEditorFloatInterface {
    editObject: object = {};
    hint: string = "hint";
    label: string = "Float Editor";
    parentDefaultValue: string | null = null;
    propertyName: string = "textValue";
    requiredText: string = "required text";
}

class TextData2 implements PropertyEditorFloatInterface {
    editObject: IDesignValidationProvider = {
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "textValue"), new ValidationIssue("issue2", "textValue")];
        },
    };
    hint: string = "hint";
    label: string = "Float Editor";
    parentDefaultValue: string | null = null;
    propertyName: string = "textValue";
    requiredText: string = "required text";
}

export const FloatPropertyEditor: StoryNode[] = [
    new StoryNode(
        (logCallback) => {
            let args = new TextData();
            return (
                <PropertyEditorFloat
                    {...args}
                    onChange={() => {
                        let d = Reflect.get(args.editObject, args.propertyName);
                        logCallback(d + "");
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Float",
        "Default",
    ),
    new StoryNode(
        (logCallback) => {
            let args = new TextData();
            return (
                <PropertyEditorFloat
                    {...args}
                    error={"Error Text"}
                    onChange={() => {
                        let d = Reflect.get(args.editObject, args.propertyName);
                        logCallback(d + "");
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Float",
        "Error",
    ),
    new StoryNode(
        (logCallback) => {
            let args = new TextData2();
            return (
                <PropertyEditorFloat
                    {...args}
                    onChange={() => {
                        let d = Reflect.get(args.editObject, args.propertyName);
                        logCallback(d + "");
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Float",
        "Validation Provider",
    ),
];
